import { auth } from "./en/auth";

import { common } from "./en/common";

import { contracts } from "./en/contracts";

import { customers } from "./en/customers";

import { dashboard } from "./en/dashboard";

import { deals } from "./en/deals";

import { documents } from "./en/documents";

import { nav } from "./en/nav";

import { organizations } from "./en/organizations";

import { products } from "./en/products";

import { quotations } from "./en/quotations";

import { reports } from "./en/reports";

import { shared } from "./en/shared";

import { systemAdmin } from "./en/systemAdmin";

import { templates } from "./en/templates";

import { profile } from "./en/profile";

import { debug } from "./en/debug";

import { status } from "./en/status";

import { onboarding } from "./en/onboarding";

import { gas } from "./en/gas";



export default {

  auth,

  common,

  nav,

  dashboard,

  customers,

  products,

  quotations,

  deals,

  reports,

  organizations,

  systemAdmin,

  profile,

  status,

  contracts,

  shared,

  debug,

  templates,

  documents,

  onboarding,

  gas

};

